export enum AuthServiceError {
  TokenExpiredException = 38005,
  HeaderNotFoundException = 14000,
  GRPCUnauthenticatedException = 16,
  SocialCredentialNotFound = 30006,
  SocialCredentialNotConnected = 30007,
  CredentialsForceReset = 34031,
  CaptchaChallenge = 'captcha-challenge',

  // Some critical response fields from the social network are empty
  InvalidSocialResponse = 10101,
}
